// @flow

import _ from 'lodash';
import { RestApi } from 'app/rgs/api';
import { cache } from 'app/v2/common/decorators/method';

import { AccidentService } from '../accident-service';
import { AccidentContract, AccidentContractCertificate } from './accident-contract-model';

type IContractsData = {
	Data: {
		Items: Array<AccidentContract>;
		Total: number;
	};
}

export type FetchContractsParams = {
	take: number;
	from: number;
	search: string;
}

export type CertificatesListByContractIdParams = {
	take: number;
	from: number;
	search: string;
}

export class AccidentContractService extends AccidentService {

	@cache('30s')
	fetchContracts = async (params: FetchContractsParams): Promise<IContractsData> => {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'contracts',
		];

		return this._api.my.get(urlParts, {query: params});
	};

	@cache('30s')
	fetchContract = async (accidentContractId: string): Promise<AccidentContract> => {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'contracts',
			accidentContractId,
		];

		return this._api.my.get(urlParts).then(({ Data }) => ({
			...Data,
			Files: Data.Files.map(file => ({
				...file,
				Url: this.getAccidentContractFileUrl(accidentContractId, file.FileID),
			})),
		}));
	};

	async fetchCertificatesListByContractId (
		accidentContractId: string, params: CertificatesListByContractIdParams
	): Promise<AccidentContractCertificate> {
		const urlParts = [
			...this.API_BASE_URL_PARTS,
			'contracts',
			`${accidentContractId}`,
			'certificates',
		];

		const query = _.defaults(params, {
			search: '',
			take: 5,
		});

		return this._api.my.get(urlParts, { query });
	}


	getCertificateListDownloadUrl = (contractId: string) => ([
		'/api',
		RestApi.API_PREFIX,
		RestApi.API_VERSION,
		...this.API_BASE_URL_PARTS,
		'contracts',
		contractId,
		'download',
	].join('/'));

	getAccidentContractFileUrl = (contractId: string, fileId: string) => ([
		'/api',
		RestApi.API_PREFIX,
		RestApi.API_VERSION,
		...this.API_BASE_URL_PARTS,
		'contracts',
		contractId,
		'files',
		fileId,
	].join('/'));
}
